// extracted by mini-css-extract-plugin
module.exports = {"colorPicker":"colorPicker___1b9o9","column":"column___1eOUl","colorBg":"colorBg___10As2","colorItem":"colorItem___21L5e","active":"active___35Oa7"};